import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "ara-textarea",
  templateUrl: "./textarea.component.html",
  styleUrls: ["./textarea.component.css"]
})
export class TextareaComponent implements OnInit {
  @Input()
  disabled: string;
  @Input()
  sourceText: string;
  @Input()
  maxLength: number;
  @Input()
  rows: number = 2;
  @Output()
  output: EventEmitter<any> = new EventEmitter<any>();
  constructor() {}
  textChanged() {
    this.output.emit(this.sourceText);
  }
  ngOnInit() {}
  toggleText(textArea, text, toggleButton) {
    if (toggleButton.target.innerText == "See More") {
      textArea.setAttribute("rows", Math.ceil(text.length / 40).toString());
      textArea.innerHTML = text;
      toggleButton.target.innerText = "See Less";
    } else if (toggleButton.target.innerText == "See Less") {
      textArea.setAttribute("rows", "2");
      textArea.innerHTML = text;
      toggleButton.target.innerText = "See More";
    }
  }
  capitalizeFirstletter() {
    if (this.sourceText)
    {
    this.sourceText =
      this.sourceText.charAt(0).toUpperCase() + this.sourceText.slice(1);
    }
  }
}
